import React from 'react';
import {
  FaClipboardList,
  FaPlusCircle,
  FaUser,
  FaSignOutAlt,
} from 'react-icons/fa';

function PatientSidebar({ activePage, visitCount, onNavigate, onNewRequest, onLogout }) {
  const linkClass = (page) =>
    `patient-sidebar-link${activePage === page ? ' active' : ''}`;

  return (
    <aside className="patient-sidebar">
      <button
        type="button"
        className={linkClass('myVisits')}
        onClick={() => onNavigate('myVisits')}
      >
        <FaClipboardList />
        <span>My Visits</span>
        {visitCount > 0 && <span className="patient-sidebar-badge">{visitCount}</span>}
      </button>

      <button
        type="button"
        className={linkClass('newRequest')}
        onClick={onNewRequest}
      >
        <FaPlusCircle />
        <span>New Request</span>
      </button>

      <button
        type="button"
        className={linkClass('profile')}
        onClick={() => onNavigate('profile')}
      >
        <FaUser />
        <span>My Profile</span>
      </button>

      <button type="button" className="patient-sidebar-link patient-sidebar-logout" onClick={onLogout}>
        <FaSignOutAlt />
        <span>Logout</span>
      </button>
    </aside>
  );
}

export default PatientSidebar;
